/* eslint-disable max-len */

import { shuffle } from 'lodash';
import { mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import store from '@/store';

export const PODCAST = {
  ITUNES: 'itunes',
  SOUNDCLOUD: 'soundcloud',
  BACKTRACKS: 'backtracks',
  POLITICAN_TRADER: 'politicantrader',
  APPLE: 'apple',
  STITCHER: 'stitcher',
};

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    title: {
      type: String,
      default: 'Featured Podcasts',
    },
    items: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
  data() {
    const defaultTracks = shuffle([
      { id: 'id1437934639', type: PODCAST.APPLE },
      { id: 'id1496616116', type: PODCAST.APPLE },
      { id: 'id1510570053', type: PODCAST.APPLE },
      { id: 'id1136826256', type: PODCAST.APPLE },
      // { id: '505391', type: PODCAST.STITCHER },
      // { id: '', type: PODCAST.POLITICAN_TRADER },
      // { id: 'https://soundcloud.com/stratfortalks', type: PODCAST.SOUNDCLOUD },
      // { id: 'stratfor/stratfor-quick-take/m/a-second-u-s-north-korea-summit', type: PODCAST.BACKTRACKS },
      // { id: '1437934639', type: PODCAST.ITUNES },
    ]);
    return {
      PODCAST,
      activeIndex: 0,
      isPlaying: true,
      tracks: this.items.length > 0 ? this.items : defaultTracks,
      swiperOptions: {
        loop: false,
        autoplay: store.getters['app/isLayoutMobile'] ? false : 5000,
        direction: 'horizontal',
        spaceBetween: 0,
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    classModifiers() {
      return {
        podcasts: true,
        [`podcasts--${this.theme}`]: this.theme,
      };
    },
    height() {
      if (this.theme === 'story') {
        return 450;
      }
      return this.isLayoutMobile ? 450 : 400;
    },
    styleItunesIframe() {
      if (this.isLayoutMobile) {
        return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px';
      }
      return 'overflow-x:hidden;overflow-y:hidden;height:300px;border:0px;width:100%';
    },
    showArrows() {
      return this.tracks.length > 1;
    },
    isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled() {
      return this.activeIndex === (this.tracks.length - 1);
    },
    prevArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--left': true,
        'podcasts__header-arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers() {
      return {
        'podcasts__header-arrow': true,
        'podcasts__header-arrow--right': true,
        'podcasts__header-arrow--disabled': this.isNextArrowDisabled,
      };
    },
  },
  methods: {
    stopSwiper() {
      this.isPlaying = false;
      this.$refs.swiper.swiper.stopAutoplay();
    },
    startSwiper() {
      this.isPlaying = true;
      this.$refs.swiper.swiper.startAutoplay();
    },
    getPoliticanTraderUrl() {
      return '//html5-player.libsyn.com/embed/destination/id/1822847/height/300/theme/custom/thumbnail/yes/direction/backward/no-cache/true/render-playlist/yes/custom-color/2607ab/';
    },
    getBacktracksUrl(id) {
      return `https://player.backtracks.fm/${id}`;
    },
    getSoundCloudUrl(track) {
      return `https://w.soundcloud.com/player/?url=${track}&auto_play=false&show_artwork=false`;
    },
    getItunesUrl(ids) {
      const width = this.isLayoutMobile ? '290' : '476';
      const query = `?c=us&d=Test&t=Test&m=podcast&e=podcast&w=${width}&h=300&ids=${ids}&wt=playlist`;
      return `//widgets.itunes.apple.com/widget.html${query}`;
    },
    getAppleUrl(id) {
      return `https://embed.podcasts.apple.com/us/podcast/star-spangled-gamblers/${id}?itsct=podcast_box&amp;itscg=30200`;
    },
    getStitcherUrl(id) {
      return `https://www.stitcher.com/embed/${id}`;
    },
    prevSlide() {
      if (!this.isPrevArrowDisabled) this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide() {
      if (!this.isNextArrowDisabled) this.$refs.swiper.swiper.slideNext();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/podcasts/podcasts.js